import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../store/auth";

export default function AdminLogin() {
  const { login, token, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (token && user) nav("/admin"); }, [token, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Connexion impossible.");
    } finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b eff-line py-3 text-sm placeholder:text-[#5a5a5a] focus:outline-none focus:border-white transition-colors duration-300";

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="w-full max-w-sm">
        <div className="text-xs tracking-eff uppercase text-muted-eff">Dashboard</div>
        <h1 className="font-display text-4xl mt-4 mb-10">EFFERVESCENCE</h1>
        <form data-testid="login-form" onSubmit={submit} className="space-y-6">
          <input data-testid="login-email" type="email" className={field} placeholder="Email" required
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className={field} placeholder="Mot de passe" required
            value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <div data-testid="login-error" className="text-xs text-muted-eff">{error}</div>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full text-xs tracking-widest uppercase border border-white py-3 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-40">
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
